var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignIllustration2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1130.04,
    height: 708.56,
    viewBox: "0 0 1130.04 708.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Header"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1130.04,
    height: 708.56
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Header",
    clipPath: "url(#clip-Header)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "convert-website-to-app",
    transform: "translate(622.841 460.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M861.523,102.209v5.733a3.36,3.36,0,0,1-3.085,3.322,3.429,3.429,0,0,1-3.651-2.446,3.743,3.743,0,0,1-.164-1.1V96.568a3.4,3.4,0,0,1,1.825-3.195,3.249,3.249,0,0,1,3.542.256,3.155,3.155,0,0,1,1.424,2.684C861.523,98.266,861.523,100.238,861.523,102.209Z",
    transform: "translate(-854.617 -92.966)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(290.365 64.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M819.191,13H291.679c-5.958,0-10.789,4.425-10.789,9.884V314.65c0,5.46,4.831,9.885,10.789,9.885H819.191c5.958,0,10.79-4.425,10.79-9.885V22.886C829.981,17.427,825.149,13,819.191,13Z",
    transform: "translate(-280.67 -12.306)",
    fill: "#eef7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M291.483,13.5H818.995c5.574,0,10.094,4.157,10.094,9.285V315.75c0,5.127-4.52,9.285-10.094,9.285H291.483c-5.574,0-10.093-4.158-10.093-9.285V22.787C281.39,17.659,285.909,13.5,291.483,13.5Z",
    transform: "translate(-280.474 -12.806)",
    fill: "none",
    stroke: "rgba(205,205,205,0.58)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M291.833,13H818.321a11.465,11.465,0,0,1,11.466,11.465V38.343H280.732V24.1a11.1,11.1,0,0,1,11.1-11.1Z",
    transform: "translate(-280.732 -13.002)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M309.179,96.134H779.033",
    transform: "translate(-269.577 19.597)",
    fill: "none",
    stroke: "#eef7ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M364.3,44.017H306.731A12.452,12.452,0,0,0,294.28,56.468v.018a12.452,12.452,0,0,0,12.451,12.451H364.3a12.451,12.451,0,0,0,12.451-12.451v-.018A12.451,12.451,0,0,0,364.3,44.017Z",
    transform: "translate(-275.419 -0.84)",
    fill: "#bcd1ff",
    stroke: "#b9daf6",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M671.686,44.4H625a4.783,4.783,0,0,0-4.783,4.783V59.587A4.783,4.783,0,0,0,625,64.371h46.684a4.783,4.783,0,0,0,4.783-4.783V49.181A4.783,4.783,0,0,0,671.686,44.4Z",
    transform: "translate(-147.608 -0.691)",
    fill: "none",
    stroke: "#c3d0f7",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M423.774,51.925h49.46",
    transform: "translate(-224.64 2.261)",
    fill: "none",
    stroke: "#c3d0f7",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M473.492,51.807h49.46",
    transform: "translate(-205.144 2.215)",
    fill: "none",
    stroke: "#c3d0f7",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M523.223,51.689h49.44",
    transform: "translate(-185.643 2.169)",
    fill: "none",
    stroke: "#c3d0f7",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M572.94,52.03h49.442",
    transform: "translate(-166.147 2.302)",
    fill: "none",
    stroke: "#c3d0f7",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M281.021,73.787h548.25",
    transform: "translate(-280.619 10.834)",
    fill: "none",
    stroke: "#c3d0f7",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M311.769,27.425a4.674,4.674,0,1,0-4.637-4.674A4.655,4.655,0,0,0,311.769,27.425Z",
    transform: "translate(-270.38 -11.012)",
    fill: "#f4b400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M324.635,27.425A4.674,4.674,0,1,0,320,22.751,4.655,4.655,0,0,0,324.635,27.425Z",
    transform: "translate(-265.334 -11.012)",
    fill: "#0f9d58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M298.917,27.425a4.674,4.674,0,1,0-4.637-4.674A4.656,4.656,0,0,0,298.917,27.425Z",
    transform: "translate(-275.419 -11.012)",
    fill: "#db4437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M806.125,90.81H294.005V241.465h512.12Z",
    transform: "translate(-275.527 17.509)",
    fill: "#f0f7fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M790.527,96.107h-487.8V232.013h487.8V96.107Z",
    transform: "translate(-272.107 19.586)",
    fill: "#f1f7fd",
    stroke: "#c3d0f7",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M313.506,196.507l39.6-74.433,35.565,48.217,19.408-26.218,29.906,53.767h35.547l14.1-16.139,41.68-47.778,42.832,63.424,33.96-51.594,37.171,52.433,55.776-65.121,18.586,37.226,21.818-16.924,30.727,47.358Z",
    transform: "translate(-267.88 29.769)",
    fill: "#c0d0fb",
    stroke: "#b9daf6",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M348.482,237.887H709.358",
    transform: "translate(-254.264 34.811)",
    fill: "none",
    stroke: "#c3d0f7",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M421.7,147.122A11.6,11.6,0,1,0,410.62,135.53,11.346,11.346,0,0,0,421.7,147.122Z",
    transform: "translate(-229.799 30.499)",
    fill: "#c0d0fb",
    stroke: "#b9daf6",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M466.2,175.406l16.834-20.612,15.92,21.287Z",
    transform: "translate(-208.004 42.599)",
    fill: "#c0d0fb",
    stroke: "#b9daf6",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M554.965,213.73H437.132a4.82,4.82,0,0,0-4.82,4.82v9.056a4.82,4.82,0,0,0,4.82,4.82H554.965a4.82,4.82,0,0,0,4.82-4.82V218.55A4.82,4.82,0,0,0,554.965,213.73Z",
    transform: "translate(-221.292 65.71)",
    fill: "#e9f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M348.482,237.887H709.358",
    transform: "translate(-254.264 55.693)",
    fill: "none",
    stroke: "#c3d0f7",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(315.134 274.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 38.537) rotate(-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M134.028,323.75l-110.147-.511A23.935,23.935,0,0,1,0,299.212L1.15,23.844A24.009,24.009,0,0,1,25.268,0L135.415.511A23.971,23.971,0,0,1,159.3,24.538l-1.168,275.387a23.955,23.955,0,0,1-24.1,23.825Z",
    transform: "translate(0)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M127.966.53H106.6A5.274,5.274,0,0,0,101.4,5.9V9.768a5.332,5.332,0,0,1-5.222,5.386l-41.628-.2a5.312,5.312,0,0,1-5.166-5.477V5.569A5.294,5.294,0,0,0,44.238.092H36.715L18.02,0A16.776,16.776,0,0,0,1.15,16.687L0,285.484a16.795,16.795,0,0,0,16.724,16.832l109.945.493a16.757,16.757,0,0,0,16.87-16.668l1.151-268.8A16.779,16.779,0,0,0,127.966.53Z",
    transform: "translate(7.304 9.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M108.777,0H0V7.284H108.777Z",
    transform: "translate(24.684 176.49)",
    fill: "#c3d0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M103.72.475c0,.256-23.224.475-51.87.475S0,.731,0,.475,23.2,0,51.85,0,103.72.22,103.72.475Z",
    transform: "translate(25.872 204.66)",
    fill: "#c3d0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M103.72.475c0,.274-23.224.493-51.87.493S0,.749,0,.475,23.2,0,51.85,0,103.72.219,103.72.475Z",
    transform: "translate(25.872 217.896)",
    fill: "#c3d0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M103.72.475c0,.256-23.224.475-51.87.475S0,.731,0,.475,23.2,0,51.85,0,103.72.22,103.72.475Z",
    transform: "translate(25.872 231.151)",
    fill: "#c3d0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M103.72.493c0,.256-23.224.475-51.87.475S0,.749,0,.493,23.2,0,51.85,0,103.72.164,103.72.493Z",
    transform: "translate(25.872 244.387)",
    fill: "#c3d0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M0,53.639,29.814,0,54.169,34.287l14.825-18.2L91.012,53.639Z",
    transform: "translate(33.704 91.504)",
    fill: "#b9daf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M15.518,7.74a7.759,7.759,0,1,1-2.279-5.474A7.769,7.769,0,0,1,15.518,7.74Z",
    transform: "translate(79.157 91.411)",
    fill: "#f6baaf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(36.665 80.759) rotate(-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M89.778,0H17.944C8.034,0,0,7.772,0,17.359v69.5c0,9.587,8.034,17.359,17.944,17.359H89.778c9.912,0,17.945-7.772,17.945-17.359v-69.5C107.723,7.772,99.69,0,89.778,0Z",
    transform: "translate(0 0)",
    fill: "#379ff0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M38.98,4.534c.393-.673.7-1.179,1.04-1.686a5.743,5.743,0,0,1,9.921,5.79c-.365.731-.787,1.406-1.18,2.109L30.773,41.883,30.1,43.119H41.734a1.507,1.507,0,0,1,.609.163,1.476,1.476,0,0,1,.487.4c2.108,3.568,4.187,7.166,6.323,10.875H5.761a5.761,5.761,0,0,1,0-11.522H15.794a1.431,1.431,0,0,0,1.461-.814Q24.534,29.547,31.9,16.928a1.406,1.406,0,0,0,0-1.659,69.61,69.61,0,0,1-3.85-6.688A5.62,5.62,0,0,1,33.19.152a5.446,5.446,0,0,1,4.553,2.331C38.108,3.13,38.474,3.775,38.98,4.534Z",
    transform: "translate(14.586 17.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M6.272,0l2.81,5.057c3.148,5.452,6.323,10.9,9.443,16.385a1.574,1.574,0,0,0,1.6.928h10.4a5.789,5.789,0,0,1,5.621,4.552,5.627,5.627,0,0,1-3.2,6.379,8.419,8.419,0,0,1-2.811.561H25.8c1.265,2.192,2.417,4.215,3.6,6.212a5.927,5.927,0,0,1,.674,5,5.626,5.626,0,0,1-4.665,3.907,5.258,5.258,0,0,1-5.424-2.276,44.353,44.353,0,0,1-2.81-4.834C11.555,32.092,5.935,22.2.314,12.534a1.745,1.745,0,0,1,0-2C2.2,7.138,4.164,3.682,6.272,0Z",
    transform: "translate(57.189 37.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M15.341,0c-1.883,3.09-3.513,6.071-5.452,8.8a5.621,5.621,0,0,1-7.166.956,5.622,5.622,0,0,1-2.3-6.943C1.485,0,1.57,0,4.436,0Z",
    transform: "translate(20.201 75.441)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(578.02 276.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(77.368 0) rotate(14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M132.4,319.806l-108.815-.511A23.735,23.735,0,0,1,0,295.562L1.15,23.533A23.735,23.735,0,0,1,24.976,0l108.8.493a23.736,23.736,0,0,1,23.59,23.734L156.21,296.255A23.732,23.732,0,0,1,132.4,319.806Z",
    transform: "translate(0 0)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M126.4.256H105.29L43.691,0H17.8C8.673,0,1.168,6.591,1.132,14.825L0,253.607c0,8.215,7.3,14.915,16.523,14.951L125.118,269c9.128,0,16.633-6.59,16.669-14.825l1.132-238.782C142.956,6.992,135.562.292,126.4.256Z",
    transform: "translate(6.846 26.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M107.445,0H0V7.193H107.445Z",
    transform: "translate(24.592 182.551)",
    fill: "#c3d0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M102.442.475c0,.256-22.949.475-51.229.475S0,.731,0,.475,22.931,0,51.212,0,102.442.22,102.442.475Z",
    transform: "translate(27.094 210.374)",
    fill: "#c3d0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M102.442.475c0,.256-22.949.457-51.229.457S0,.731,0,.475,22.931,0,51.212,0,102.442.2,102.442.475Z",
    transform: "translate(27.094 223.465)",
    fill: "#c3d0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M102.442.457c0,.255-22.949.475-51.229.475S0,.711,0,.457,22.931,0,51.212,0,102.442.2,102.442.457Z",
    transform: "translate(27.094 236.555)",
    fill: "#c3d0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M102.442.475c0,.256-22.949.475-51.229.475S0,.731,0,.475,22.931,0,51.212,0,102.442.22,102.442.475Z",
    transform: "translate(27.094 249.425)",
    fill: "#c3d0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M102.442.475c0,.256-22.949.475-51.229.475S0,.731,0,.475,22.931,0,51.212,0,102.442.22,102.442.475Z",
    transform: "translate(27.094 274.31)",
    fill: "#c3d0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M102.442.455c0,.274-22.949.475-51.229.475S0,.729,0,.455,22.931,0,51.212,0,102.442.2,102.442.455Z",
    transform: "translate(27.094 289.154)",
    fill: "#c3d0f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M0,53.639,29.8,0,54.169,34.287l14.807-18.2L91.012,53.639Z",
    transform: "translate(32.81 97.71)",
    fill: "#b9daf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M15.519,7.76a7.745,7.745,0,1,1-.585-2.968A7.76,7.76,0,0,1,15.519,7.76Z",
    transform: "translate(79.775 98.094)",
    fill: "#f6baaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M55.575,0H2.227A2.227,2.227,0,0,0,0,2.227v.018A2.227,2.227,0,0,0,2.227,4.473H55.575A2.227,2.227,0,0,0,57.8,2.246V2.227A2.227,2.227,0,0,0,55.575,0Z",
    transform: "translate(49.66 14.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M7.96,15.92A7.96,7.96,0,1,0,0,7.96,7.96,7.96,0,0,0,7.96,15.92Z",
    transform: "translate(70.73 299.45)",
    fill: "#91afc9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(88.601 61.348) rotate(14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M89.778,0H17.943C8.033,0,0,7.772,0,17.36V86.854c0,9.587,8.033,17.361,17.943,17.361H89.778c9.91,0,17.945-7.774,17.945-17.361V17.36C107.723,7.772,99.688,0,89.778,0Z",
    fill: "#93ba30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M19.266,0H36.374c1.6,0,2.215.589,2.215,2.159V29.588a8.719,8.719,0,0,1-6.422,8.721c-.5,0-.56.366-.56.785v8.163a5.345,5.345,0,0,1-.381,2.089,5.3,5.3,0,0,1-5.032,3.323,5.185,5.185,0,0,1-5.1-5.021V39.432c0-.618-.169-.843-.785-.787a12.47,12.47,0,0,1-2.076,0c-.56,0-.729.169-.729.729v7.994a5.216,5.216,0,0,1-5.468,5.3,5.332,5.332,0,0,1-5.049-5.442V39.235a.811.811,0,0,0,0-.329.833.833,0,0,0-.128-.3.856.856,0,0,0-.235-.229.828.828,0,0,0-.306-.122A8.6,8.6,0,0,1,0,29.84V2.1C0,.673.644.056,2.047.056Z",
    transform: "translate(34.567 40.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M0,13.983V5.093A5.244,5.244,0,0,1,10.293,3.831a5.607,5.607,0,0,1,.224,1.683V22.48A5.273,5.273,0,0,1,0,23.126Z",
    transform: "translate(76.957 41.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M38.182,22.183A19.192,19.192,0,0,0,29.151,9.675c-.562-.336-.59-.589-.338-1.122.843-1.907,1.627-3.842,2.468-5.749C31.9,1.346,31.591.561,30.16,0h-.813a2.156,2.156,0,0,0-1.572,1.514c-.729,1.795-1.542,3.59-2.3,5.384-.2.449-.394.785-1.01.617a19.19,19.19,0,0,0-10.154,0A.9.9,0,0,1,13.108,6.9l-2.3-5.384A2.105,2.105,0,0,0,9.265,0H8.256C6.883.9,6.714,1.486,7.387,3S8.874,6.619,9.714,8.357c.366.785.252,1.094-.5,1.57a18.929,18.929,0,0,0-9.2,16.21,1.795,1.795,0,0,0,.813,1.711,2.8,2.8,0,0,0,1.486.281H36.246a3.224,3.224,0,0,0,.729,0A1.737,1.737,0,0,0,38.6,26.306,15.919,15.919,0,0,0,38.182,22.183ZM12.21,21.005a1.712,1.712,0,0,1-1.236-.579,1.7,1.7,0,0,1-.417-1.3,1.626,1.626,0,0,1,.154-.65,1.655,1.655,0,0,1,1.64-.949,1.767,1.767,0,0,1,1.683,1.767,1.8,1.8,0,0,1-1.824,1.711Zm14.163,0a1.739,1.739,0,1,1,0-3.477,1.662,1.662,0,0,1,.665.114,1.645,1.645,0,0,1,.562.369,1.667,1.667,0,0,1,.37.563,1.639,1.639,0,0,1,.113.664,1.678,1.678,0,0,1-.113.672,1.7,1.7,0,0,1-.366.574,1.736,1.736,0,0,1-.562.385A1.709,1.709,0,0,1,26.373,21.005Z",
    transform: "translate(34.555 11.359)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M0,13.983V5.093A5.244,5.244,0,0,1,10.293,3.831a5.607,5.607,0,0,1,.224,1.683V22.48A5.273,5.273,0,0,1,0,23.126Z",
    transform: "translate(20.122 41.513)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignIllustration2);
export default __webpack_public_path__ + "static/media/design-illustration-2.be02ef91c35d08b0158d4203763fd790.svg";
export { ForwardRef as ReactComponent };